import { NavMarker } from 'react-rhumb';
import { View } from 'foundations-components/components/View';
import { TopBar } from '../TopBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PageLayout({
  children
}) {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "INDEX_LOAD",
    children: /*#__PURE__*/_jsxs(View, {
      maxBlockSize: "100%",
      backgroundColor: "fill-surface-recessed",
      minBlockSize: "100vh",
      children: [/*#__PURE__*/_jsx(TopBar, {}), children]
    })
  });
}